import { useLocation } from "react-router-dom"
import Distributer from "../../components/distributer/Distributer"

function DistributerPage() {
     const location =  useLocation()
    return (
        <>
            <Distributer key={location.key} />
        </>
    )
}
export default DistributerPage